import * as yup from 'yup';

const pauseEmployeeSchema = yup.object().shape({
  reason: yup.string().required('Reason is mandatory'),
});

export default pauseEmployeeSchema;
